import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';

class Paid extends PureComponent {
	render() {
		const { hash } = this.props;

		return (
			<div className="margin-top-30 text-center margin-left-20 margin-right-20">
				<div className="text-center margin-bottom-30 padding-left-10 padding-right-10">
					<div className="margin-bottom-20">
						<i className="rkf rkf-check-mark-o-solid font-size-44 color-green-limeade" />
					</div>
					<div className="margin-bottom-20">
						<span className="font-medium font-size-20">Payment Successful</span>
					</div>
					<div>
						<span className="color-gray-shuttle">
							Your payment was already processed successfully
						</span>
					</div>
				</div>

				<div className="quickpay-paid">
					<div className="margin-top-30 margin-bottom-20">
						<span className="font-size-24 font-semi-bold">Hire Officers Regularly?</span>
					</div>
					<div className="margin-bottom-15">
						<span className="color-gray-shuttle">
							Create an account to view the details of upcoming jobs across all of your locations,
							approve and pay multiple invoices at the same time, and keep up with the coordinators
							or agencies you work with.
						</span>
					</div>
					<div className="padding-bottom-40">
						<Row>
							<Col sm={3} xs={12} />
							<Col sm={6} xs={12}>
								<a
									href={`/signup?quickpayToken=${hash}`}
									className="btn btn-primary form-control"
								>
									Create an Account
									<i className="rkf rkf-arrow-right margin-left-5" />
								</a>
							</Col>
							<Col sm={3} xs={12} />
						</Row>
					</div>
				</div>
			</div>
		);
	}
}

Paid.propTypes = {
	hash : PropTypes.string,
};

Paid.defaultProps = {
	hash : '',
};

export default Paid;
